import { createContext, ReactNode, useContext, useState } from 'react';

export interface PopupContextType {
  trigger: boolean;
  setTrigger: (args0: boolean) => void;
  title: string;
  setTitle: (args0: string) => void;
  message: string;
  setMessage: (args0: string) => void;
  method: string;
  setMethod: (args0: string) => void;
  executeMethod: string;
  setExecuteMethod: (args0: string) => void;
  action: string;
  setAction: (args0: string) => void;
  pk: string;
  setPk: (args0: string) => void;
  sk: string;
  setSk: (args0: string) => void;
}

// Context provider component
interface FormContextProviderProps {
  children: ReactNode;
}

const PopupContext = createContext<PopupContextType | undefined>(undefined);

export const PopupContextProvider = ({
  children,
}: FormContextProviderProps): JSX.Element => {
  const [trigger, setTrigger] = useState<boolean>(false);
  const [title, setTitle] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const [method, setMethod] = useState<string>('');
  const [action, setAction] = useState<string>('');
  const [executeMethod, setExecuteMethod] = useState<string>('');
  const [pk, setPk] = useState<string>('');
  const [sk, setSk] = useState<string>('');

  return (
    <PopupContext.Provider
      value={{
        trigger,
        setTrigger,
        title,
        setTitle,
        message,
        setMessage,
        method,
        setMethod,
        action,
        setAction,
        executeMethod,
        setExecuteMethod,
        pk,
        setPk,
        sk,
        setSk
      }}
    >
      {children}
    </PopupContext.Provider>
  );
};

export const usePopupContext = (): PopupContextType => {
  const context = useContext(PopupContext);
  if (!context) {
    throw new Error(
      'usePopupContext must be used within a PopupContextProvider'
    );
  }
  return context;
};
